import { render, staticRenderFns } from "./my-business-install-orders.vue?vue&type=template&id=50bebd4f&scoped=true"
import script from "./my-business-install-orders.vue?vue&type=script&lang=js"
export * from "./my-business-install-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bebd4f",
  null
  
)

export default component.exports